interface BadgeProduct {
  price: number | null;
  salePrice: number | null;
  availableSizes?: string[];
  personalized?: boolean;
  merchandisingBadge?: {kind:string;text:string;detail:string};
}

const labels: Record<string, { deal: string; sizes: (count: number) => string; recommended: string }> = {
  ro: { deal: "Preț redus", sizes: (count) => `${count} mărimi disponibile`, recommended: "Recomandat pentru tine" },
  en: { deal: "Reduced price", sizes: (count) => `${count} sizes available`, recommended: "Recommended for you" },
  it: { deal: "Prezzo ridotto", sizes: (count) => `${count} taglie disponibili`, recommended: "Consigliato per te" },
  de: { deal: "Reduzierter Preis", sizes: (count) => `${count} Größen verfügbar`, recommended: "Für dich empfohlen" },
  fr: { deal: "Prix réduit", sizes: (count) => `${count} tailles disponibles`, recommended: "Recommandé pour vous" }
};

export function productBadge(product: BadgeProduct, locale: string, options: { showPrices: boolean; recommended?: boolean }) {
  const copy = labels[locale] ?? labels.en!;
  const evidence=product.merchandisingBadge;
  if(evidence && ['bestseller','appreciated','personalized'].includes(evidence.kind)) {
    const translated:Record<string,string[]>={ro:['Cel mai vândut','Foarte apreciat','Recomandat pentru tine'],en:['Bestseller','Highly rated','Recommended for you'],it:['Più venduto','Molto apprezzato','Consigliato per te'],de:['Bestseller','Sehr gut bewertet','Für dich empfohlen'],fr:['Meilleure vente','Très apprécié','Recommandé pour vous']};
    const i=['bestseller','appreciated','personalized'].indexOf(evidence.kind);
    return {text:(translated[locale]??translated.en)![i]!,kind:evidence.kind,title:evidence.detail};
  }
  const { price, salePrice } = product;
  if (options.showPrices && price !== null && salePrice !== null &&
      Number.isFinite(price) && Number.isFinite(salePrice) && salePrice > 0 && salePrice < price) {
    return { text: copy.deal, kind: "deal" };
  }
  const count = new Set((product.availableSizes ?? []).map((size) => size.trim()).filter(Boolean)).size;
  if (count >= 5) return { text: copy.sizes(count), kind: "sizes" };
  if (product.personalized === true) return { text: copy.recommended, kind: "recommended" };
  return null;
}
